export class TextUtils {
  static stripHtml(str: string): string {
    if (!str) {
      return '';
    }
    return str.replace( /(<([^>]+)>)/ig, '');
  }
}
